import styled from 'styled-components';
import { Switch } from 'antd';

export const PageWrapper = styled.div`
  padding: 0;
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
`;

export const SearchDisabledWrapper = styled.span`
  display: inline-block;
  cursor: not-allowed;

  input:disabled {
    opacity: 1;
    -webkit-text-fill-color: inherit;
  }
`;

export const OptionNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const OptionThumbnailWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
`;

export const ThumbnailImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
`;

export const NoImagePlaceholder = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #f5f5f5;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c0c0;
  flex-shrink: 0;
`;

export const OptionEyeBadge = styled.div`
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #7c3aed;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 1;
`;

export const PreviewImg = styled.img`
  max-width: 80vw;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
`;

export const OptionNameText = styled.span`
  font-weight: 600;
`;

export const DescriptionText = styled.span`
  color: #888;
  font-size: 13px;
`;

export const StatusTag = styled.span<{ $isDark: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  ${({ $isDark }) =>
    $isDark
      ? 'background:rgba(251,191,36,0.12);border:1px solid rgba(251,191,36,0.3);color:#fbbf24;'
      : 'background:#fff7e6;border:1px solid #ffd591;color:#d46b08;'}
`;

export const SoldOutSwitchWrap = styled.div<{ $busy: boolean }>`
  display: inline-block;
  cursor: ${({ $busy }) => ($busy ? 'not-allowed' : 'pointer')};
`;

export const SoldOutSwitch = styled(Switch).withConfig({
  shouldForwardProp: (prop) => prop !== '$soldOut',
})<{ $soldOut?: boolean }>`
  ${({ $soldOut }) => $soldOut && 'background: #ff4d4f !important;'}

  .ant-switch-inner .ant-switch-inner-checked,
  .ant-switch-inner .ant-switch-inner-unchecked {
    color: #fff !important;
  }
`;
